export enum CubiscanVersion {
  CUBISCAN_25 = "Cubiscan25",
  CUBISCAN_100 = "Cubiscan100",
  CUBISCAN_110 = "Cubiscan110",
  CUBISCAN_125 = "Cubiscan125",
  CUBISCAN_150 = "Cubiscan150",
  CUBISCAN_325 = "Cubiscan325",
  CUBISCAN_325_V2 = "Cubiscan325_V2"
}
